import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Quote } from 'lucide-react';
export function Proof() {
  return <section className="py-24 bg-sage-50 relative overflow-hidden" data-id="element-189">
      <div className="absolute top-0 right-0 w-64 h-64 bg-sage-200 rounded-full mix-blend-multiply filter blur-3xl opacity-50 translate-x-1/2 -translate-y-1/2" data-id="element-190"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-terracotta-light rounded-full mix-blend-multiply filter blur-3xl opacity-50 -translate-x-1/2 translate-y-1/2" data-id="element-191"></div>

      <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-192">
        <FadeIn data-id="element-193">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-soft text-center relative" data-id="element-194">
            <Quote className="absolute top-6 left-6 text-sage-200 w-16 h-16 -z-10 rotate-180" data-id="element-195" />

            <p className="text-xl md:text-2xl font-serif text-charcoal leading-relaxed mb-8 relative z-10" data-id="element-196">
              "En solo 7 días, pasarás de temer las salidas de casa a sentirte
              el <strong data-id="element-197">'ancla'</strong> de tu familia. No prometo que los
              berrinches desaparezcan para siempre —son parte del crecimiento—
              pero prometo que{' '}
              <strong data-id="element-198">
                dejarán de controlar tu vida, tu humor y tu paz mental.
              </strong>
              "
            </p>

            <div className="flex items-center justify-center gap-4" data-id="element-199">
              <div className="w-12 h-12 rounded-full bg-sage-200 flex items-center justify-center text-sage-700 font-bold text-xl" data-id="element-200">
                ✓
              </div>
              <div className="text-left" data-id="element-201">
                <p className="font-bold text-charcoal" data-id="element-202">Resultados Reales</p>
                <p className="text-sm text-charcoal-light" data-id="element-203">
                  Probado por cientos de familias
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}